import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppTheme from './app-theme';
import { EventContextProvider } from './common/EventContext';
import { ConnectionProvider } from '@sezenta/connection';
import { FormConfigProvider } from './common/FormConfigProvider';
import { BrowserRouter } from 'react-router-dom';
import { environment } from './environments/environment';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <EventContextProvider>
      <ConnectionProvider
        baseUrl={environment.baseUrl}
        cookieDomain={environment.cookieDomain}
      >
        <FormConfigProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </FormConfigProvider>
      </ConnectionProvider>
    </EventContextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
